import { useNavigate, useLocation } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-[#0c0c0c] px-6 overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none opacity-15"
        style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)',
          backgroundSize: '80px 80px',
        }}
      />

      <div className="absolute top-0 left-0 w-32 h-px bg-white/10" />
      <div className="absolute top-0 left-0 w-px h-32 bg-white/10" />
      <div className="absolute bottom-0 right-0 w-32 h-px bg-white/10" />
      <div className="absolute bottom-0 right-0 w-px h-32 bg-white/10" />

      <span className="absolute select-none pointer-events-none font-black text-white/[0.03] leading-none"
        style={{ fontSize: 'clamp(10rem, 30vw, 22rem)' }}>
        404
      </span>

      <div className="relative z-10 flex flex-col items-center text-center max-w-md">
        <p className="font-mono text-xs text-neutral-600 tracking-widest uppercase mb-6">
          // page not found
        </p>

        <h1 className="font-black text-white text-4xl md:text-5xl tracking-tight leading-none mb-4">
          Lost in<br />
          <span className="text-neutral-600">the void.</span>
        </h1>

        <div className="flex items-center gap-2 border border-white/8 px-4 py-2 mb-6">
          <i className="ri-map-pin-line text-xs text-neutral-600" />
          <span className="font-mono text-xs text-neutral-500 tracking-wider">
            {location.pathname}
          </span>
        </div>

        <p className="text-neutral-500 text-sm leading-relaxed mb-10">
          This page doesn&apos;t exist or has been moved. Head back home and find what you&apos;re looking for.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 w-full">
          <button
            onClick={() => navigate('/')}
            className="group relative w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white text-black font-mono text-xs font-bold tracking-widest uppercase overflow-hidden transition-all duration-300 hover:scale-105 sm:whitespace-nowrap cursor-pointer"
          >
            <span className="relative z-10 group-hover:text-white transition-colors duration-300 flex items-center gap-2">
              <i className="ri-home-4-line text-base" />
              Go Home
            </span>
            <div className="absolute inset-0 bg-black translate-x-[-101%] group-hover:translate-x-0 transition-transform duration-300" />
          </button>

          <button
            onClick={() => navigate(-1)}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-white/20 text-white font-mono text-xs tracking-widest uppercase hover:border-white/50 transition-all duration-300 sm:whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line text-base" />
            Go Back
          </button>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 border-t border-white/5 px-6 lg:px-14 py-4 flex items-center justify-between">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-3 group cursor-pointer"
        >
          <div className="w-7 h-7 border border-white/20 group-hover:border-white transition-colors duration-300 flex items-center justify-center">
            <span className="text-white font-black text-xs">G</span>
          </div>
          <span className="font-mono text-xs text-neutral-600 tracking-widest uppercase group-hover:text-neutral-400 transition-colors duration-300">G-Software</span>
        </button>
      </div>
    </div>
  );
}

